import React from 'react';

export const PermissionLoadingContext = React.createContext<{
  isFetching: boolean;
  isLoading: boolean;
} | null>(null);

export const useAppPermissions = () => {
  const permissionLoadingContext = React.useContext(PermissionLoadingContext);
  if (permissionLoadingContext == null) {
    throw new Error('This component should be wrapped by PermissionLoadingContext');
  }

  return { permissionLoadingContext };
};
